// TabContent.jsx
import React from "react";

const TabContent = ({ tabs, activeTab }) => {
  const ActiveComponent = tabs[activeTab].component;
  return <ActiveComponent />;
};

export default TabContent;
